import { useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Link } from "react-router";
import { forgotPasswordSchema, type ForgotPasswordInput } from "@theadam/shared";
import { Button } from "@/components/ui/button";
import { Field, Input } from "@/components/ui/form";
import { Alert } from "@/components/ui/misc";
import { ApiError, api } from "@/lib/api";
import { AuthLayout } from "./AuthLayout";

export function ForgotPasswordPage() {
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const form = useForm<ForgotPasswordInput>({ resolver: zodResolver(forgotPasswordSchema), defaultValues: { email: "" } });

  const onSubmit = form.handleSubmit(async (values) => {
    setError(null);
    try {
      await api.post("/auth/forgot-password", values);
      setDone(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "İstek gönderilemedi");
    }
  });

  return (
    <AuthLayout title="Şifre sıfırlama" subtitle="Hesabınıza bağlı e-posta adresini girin.">
      {done ? (
        <div className="space-y-6">
          <Alert tone="success" title="İsteğiniz alındı">
            Bu e-posta kayıtlıysa 1 saat geçerli bir sıfırlama bağlantısı gönderildi. Gelen kutunuzu ve istenmeyen klasörünü kontrol edin.
          </Alert>
          <Button asChild variant="outline" className="w-full">
            <Link to="/giris">Girişe dön</Link>
          </Button>
        </div>
      ) : (
        <form onSubmit={onSubmit} noValidate className="space-y-5">
          {error && <Alert tone="danger" title={error} />}
          <Field label="E-posta" error={form.formState.errors.email?.message}>
            {(p) => <Input {...p} type="email" autoComplete="email" autoFocus {...form.register("email")} />}
          </Field>
          <Button type="submit" className="w-full" size="lg" loading={form.formState.isSubmitting}>
            Sıfırlama bağlantısı gönder
          </Button>
          <Link to="/giris" className="block text-center text-sm text-muted-foreground hover:text-foreground">
            Girişe dön
          </Link>
        </form>
      )}
    </AuthLayout>
  );
}
